module.exports = __webpack_public_path__ + "static/images/chat-in-app.-4lqQ4V.svg";